<div class="misc-wrapper">
  <div class="misc-inner p-2 p-sm-3">
    <div class="w-100 text-center" *ngIf="orderDetails">
      <!-- Payment confirmed -->
      <h2 *ngIf="orderDetails.paymentStatus === paymentStatusEnum.PAYMENT_CONFIRMED ||
            orderDetails.paymentStatus === paymentStatusEnum.PAYMENT_PAID" class='mb-1'>
        {{'RETURN_URL_PAYMENT.PAYMENT_SUCCESSFUL' | translate }}
      </h2>

      <!-- Generic pending / declined (all other statuses) -->
      <h2 *ngIf="orderDetails.paymentStatus !== paymentStatusEnum.PAYMENT_CONFIRMED
                  && orderDetails.paymentStatus !== paymentStatusEnum.PAYMENT_PAID" class="mb-1">
        {{ (!orderDetails.ipnErrorCode ? 'RETURN_URL_PAYMENT.PAYMENT_PENDING' : 'RETURN_URL_PAYMENT.PAYMENT_UNSUCCESSFUL') | translate }}️
      </h2>

      <p class="mb-2">{{ 'RETURN_PAYMENT.SUBTITLE' | translate }}️</p>
      <ul>
        <li>
          <p>
            {{ 'RETURN_PAYMENT.ORDER_ID' | translate }}
            <span>{{ orderId }}</span>
          </p>
        </li>
        <li>
            <div *ngIf="orderDetails.ipnErrorCode != '0' ">
              {{ ipnStatusesLabels[orderDetails.ipnErrorCode] | translate}}
            </div>
        </li>
      </ul>
      <a
        class="btn btn-primary mt-2 mb-2 btn-sm-block"
        [routerLink]="['/' + subdomain + '/benefits-history/']"
        rippleEffect
      >
        {{ 'RETURN_PAYMENT.HISTORY_LINK' | translate }}
      </a>
    </div>
  </div>
</div>
